const StrengthsSection = () => {
  const strengths = [
    {
      icon: 'ri-user-star-line',
      title: '現役エンジニアが直接対応',
      description: '経験豊富な現場エンジニアが、実務に即した自動化ソリューションを提供します。技術力と実務経験を兼ね備えた専門家がプロジェクトを担当。',
      features: ['Google Apps Script・Excel VBA対応', 'AI・機械学習の専門知識', '豊富な業務自動化経験'],
      image: 'https://static.readdy.ai/image/f944b6b09380cffeaef8984d28dd405e/6800d04ca70ea5a2f96e3fe245258bac.png'
    },
    {
      icon: 'ri-question-answer-line',
      title: '業務内容が未定でもヒアリングから対応可能',
      description: '「何を自動化すべきかわからない」という状態からでも大丈夫。現状の業務フローを詳細にヒアリングし、最適な自動化ポイントをご提案します。',
      features: ['業務フロー分析', '課題の可視化', '優先順位の提案'],
      image: 'https://static.readdy.ai/image/f944b6b09380cffeaef8984d28dd405e/a36478b3aa45d00977060f9df7caabed.png'
    },
    {
      icon: 'ri-tools-line',
      title: '幅広い自動化ツールに対応',
      description: 'Google Apps Script・Excel VBA・AIエージェント・各種ツール連携など、多様な技術スタックに対応し、お客様の環境に最適なソリューションを提供します。',
      features: ['Google Workspace・Microsoft 365連携', 'Excel VBA・GAS開発', 'AI・ChatGPT活用', 'LINE Bot・Slack・Teams連携'],
      image: 'https://static.readdy.ai/image/f944b6b09380cffeaef8984d28dd405e/d1b7f591e9fff2766facd5b70fd17dee.png'
    }
  ];

  return (
    <section id="strengths" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            サービスの<span className="text-blue-600">強み</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            他社にはない独自の強みで、お客様の業務効率化を成功に導きます
          </p>
        </div>

        <div className="space-y-12">
          {strengths.map((strength, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="lg:w-1/2">
                <div className="bg-gray-50 rounded-xl p-8">
                  <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-6">
                    <i className={`${strength.icon} text-2xl text-blue-600`}></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {strength.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-6">
                    {strength.description}
                  </p>
                  <ul className="space-y-2">
                    {strength.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-green-600 mr-3"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="lg:w-1/2">
                <img 
                  src={strength.image}
                  alt={strength.title}
                  className="w-full h-auto rounded-xl shadow-lg object-cover"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-8 text-white text-center">
          <h3 className="text-2xl font-bold mb-4">まずは無料相談から始めませんか？</h3>
          <p className="text-blue-100 mb-6">
            現在の業務課題をお聞かせください。丁寧なヒアリングを通じて最適な自動化プランをご提案いたします。
          </p>
          <button 
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            今すぐ相談する
          </button>
        </div>
      </div>
    </section>
  );
};

export default StrengthsSection;
